import React from 'react';

const ClientPendoView = () => (
	<div className="account-client-pendo-view">
		<div className="endicia-logo" />
	</div>
);

export default ClientPendoView;
